// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3KCas","select":"Header_select__Olfmq","clinic":"Header_clinic__3bNRt"};